/* eslint-disable */
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/connections": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get All Connections
     * @description Retrieves a list of all document connections across all customers.
     */
    get: operations["getApiConnections"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/connections/{customerId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Connections for Customer
     * @description Retrieves a list of document connections for a specific customer.
     */
    get: operations["getApiConnectionsByCustomerId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List all customers
     * @description Retrieves a paginated list of all customers in the system.
     */
    get: operations["getApiCustomers"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/documents": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List documents for a customer
     * @description Retrieves a paginated list of financial documents for a specific customer with optional date filtering.
     */
    get: operations["getApiCustomersByCustomerIdDocuments"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/documents/{documentId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get document details
     * @description Retrieves detailed information about a specific financial document.
     */
    get: operations["getApiCustomersByCustomerIdDocumentsByDocumentId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/documents/{documentId}/artifact": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download document artifact
     * @description Downloads the PDF artifact for a specific financial document.
     */
    get: operations["getApiCustomersByCustomerIdDocumentsByDocumentIdArtifact"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    /** @description Details of an HTTP 400 error. */
    ApiErrorDetails400: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Bad Request
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 400
       * @constant
       */
      statusCode: 400;
    };
    /** @description Details of an HTTP 401 error. */
    ApiErrorDetails401: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Unauthorized
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 401
       * @constant
       */
      statusCode: 401;
    };
    /** @description Details of an HTTP 404 error. */
    ApiErrorDetails404: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Not Found
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 404
       * @constant
       */
      statusCode: 404;
    };
    /** @description Details of an HTTP 500 error. */
    ApiErrorDetails500: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example InternalServerError
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Internal Server Error
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 500
       * @constant
       */
      statusCode: 500;
    };
    Connection: {
      /** @description ISO timestamp when the connection was archived */
      archivedAt: string | null;
      /** @description ISO timestamp when the connection was created */
      createdAt: string;
      /** @description The customer identifier */
      customerId: string;
      /** @description ISO date for historical data retrieval start */
      historicalStartDate: string | null;
      /** @description ISO timestamp of the last successful sync */
      lastSyncedAt: string | null;
      /** @description The reference identifier for the connection */
      reference: string;
      /**
       * @description The current state of the connection
       * @enum {string}
       */
      state: "pending" | "active" | "errored";
      /** @description The target system (e.g., MAESN, DATEV) */
      targetSystem: string;
      /** @description ISO timestamp when the connection was last updated */
      updatedAt: string;
    };
    /**
     * @description Customer object
     * @example {
     *       "customerId": "945163ef-cbb2-467e-a74d-b8b03d065aa0"
     *     }
     */
    Customer: {
      /**
       * Format: uuid
       * @description Unique identifier for the customer
       * @example 945163ef-cbb2-467e-a74d-b8b03d065aa0
       */
      customerId: string;
    };
    ErrorResponse400: {
      error: components["schemas"]["ApiErrorDetails400"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse401: {
      error: components["schemas"]["ApiErrorDetails401"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse404: {
      error: components["schemas"]["ApiErrorDetails404"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse500: {
      error: components["schemas"]["ApiErrorDetails500"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    /**
     * @description Financial document object
     * @example {
     *       "id": "d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6",
     *       "documentNumber": "INV-2024-001",
     *       "documentDate": "2024-01-15",
     *       "createdAt": "2024-01-15T10:30:00Z",
     *       "updatedAt": "2024-01-16T14:20:00Z",
     *       "totalAmount": 1250.5,
     *       "currency": "EUR",
     *       "name": "Monthly Service Invoice",
     *       "documentType": "INVOICE"
     *     }
     */
    FinancialDocument: {
      /**
       * Format: date-time
       * @description Document creation timestamp
       * @example 2024-01-15T10:30:00Z
       */
      createdAt: string;
      /**
       * @description Currency code
       * @example EUR
       */
      currency: string;
      /**
       * @description Date when the document was issued
       * @example 2024-01-15
       */
      documentDate: string;
      /**
       * @description Document number
       * @example INV-2024-001
       */
      documentNumber: string;
      /**
       * @description Type of financial document
       * @example INVOICE
       * @enum {string}
       */
      documentType: "BILL" | "INVOICE";
      /**
       * Format: uuid
       * @description Unique identifier for the document
       * @example d1e2f3g4-h5i6-j7k8-l9m0-n1o2p3q4r5s6
       */
      id: string;
      /**
       * @description Document name or description
       * @example Monthly Service Invoice
       */
      name: string;
      /**
       * @description Total amount of the document
       * @example 1250.5
       */
      totalAmount: number;
      /**
       * Format: date-time
       * @description Document last update timestamp
       * @example 2024-01-16T14:20:00Z
       */
      updatedAt: string;
    };
    /** @description Standard pagination information */
    PaginationInfo: {
      /**
       * @description Maximum number of items returned per page
       * @example 10
       */
      limit: number;
      /**
       * @description Number of items skipped from the beginning
       * @example 0
       */
      offset: number;
      /**
       * @description Total number of items available
       * @example 100
       */
      total: number;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type ApiErrorDetails400 = components["schemas"]["ApiErrorDetails400"];
export type ApiErrorDetails401 = components["schemas"]["ApiErrorDetails401"];
export type ApiErrorDetails404 = components["schemas"]["ApiErrorDetails404"];
export type ApiErrorDetails500 = components["schemas"]["ApiErrorDetails500"];
export type Connection = components["schemas"]["Connection"];
export type Customer = components["schemas"]["Customer"];
export type ErrorResponse400 = components["schemas"]["ErrorResponse400"];
export type ErrorResponse401 = components["schemas"]["ErrorResponse401"];
export type ErrorResponse404 = components["schemas"]["ErrorResponse404"];
export type ErrorResponse500 = components["schemas"]["ErrorResponse500"];
export type FinancialDocument = components["schemas"]["FinancialDocument"];
export type PaginationInfo = components["schemas"]["PaginationInfo"];
export type $defs = Record<string, never>;
export interface operations {
  getApiConnections: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of all connections. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Connection"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description No connections found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiConnectionsByCustomerId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of connections for the customer. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Connection"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomers: {
    parameters: {
      query?: {
        limit?: number;
        page?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of customers. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Customer"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description Internal server error. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdDocuments: {
    parameters: {
      query?: {
        limit?: number;
        page?: number;
        updatedAfter?: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of documents. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FinancialDocument"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Customer not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description Internal server error. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdDocumentsByDocumentId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        documentId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the document. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FinancialDocument"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Document or customer not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description Internal server error. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdDocumentsByDocumentIdArtifact: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        documentId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the document artifact. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            /**
             * Format: binary
             * @description PDF file binary data
             */
            data?: unknown;
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Document or customer not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description Internal server error. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
}
export enum ApiPaths {
  getApiConnections = "/api/connections",
  getApiConnectionsByCustomerId = "/api/connections/{customerId}",
  getApiCustomers = "/api/customers",
  getApiCustomersByCustomerIdDocuments = "/api/customers/{customerId}/documents",
  getApiCustomersByCustomerIdDocumentsByDocumentId = "/api/customers/{customerId}/documents/{documentId}",
  getApiCustomersByCustomerIdDocumentsByDocumentIdArtifact = "/api/customers/{customerId}/documents/{documentId}/artifact",
}
